export const makeSelectValuesFromEnum = (enumeration) => {
    return Object.values(enumeration).map(value => ({ value, text: value }));
};
